export default ({ active, mainEventId }) => ({
    active,
    mainEventId,
    hasCustomerExtendedAccess: null,
    async init() {
        this.$watch('hasCustomerExtendedAccess', () => {
            if(this.hasCustomerExtendedAccess !== null) {
                localStorage.setItem(
                    `main_event_status_${this.mainEventId}`,
                    this.hasCustomerExtendedAccess
                );
            }
        });

        !this.active && await this.loadCustomerExtendedAccess()

        const resetStatusListener = async () => {
            this.clear();
            await this.loadCustomerExtendedAccess();
        };

        window.addEventListener('beforeunload', () => this.clear());
        window.addEventListener('reset-main-event-navbar-status', resetStatusListener);
    },
    async loadCustomerExtendedAccess() {
        if (this.hasCustomerExtendedAccess !== null || this.active) {
            return;
        }

        try {
            this.hasCustomerExtendedAccess = await this.$wire.call('getHasCustomerExtendedAccess');
        } catch (e) {
            this.hasCustomerExtendedAccess = false;
        }
    },
    getClasses() {
        return {
            'bg-green-400': (this.active && !this.hasCustomerExtendedAccess) || this.active,
            'bg-blue-400': !this.active && this.hasCustomerExtendedAccess,
            'relative inline-flex size-2 min-w-2 rounded-full': true
        }
    },
    clear() {
        this.hasCustomerExtendedAccess = null;
        localStorage.removeItem(`main_event_status_${this.mainEventId}`)
    },
});
